import { forwardRef } from "react";
import {
  TextInput,
  Textarea as MantineTextarea,
  Select as MantineSelect,
  Checkbox as MantineCheckbox,
  type TextInputProps,
  type TextareaProps as MantineTextareaProps,
  type SelectProps as MantineSelectProps,
  type CheckboxProps as MantineCheckboxProps,
} from "@mantine/core";

interface InputProps extends Omit<TextInputProps, "error"> {
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ error, ...props }, ref) => {
  return <TextInput ref={ref} error={error} {...props} />;
});

Input.displayName = "Input";

interface TextareaProps extends Omit<MantineTextareaProps, "error"> {
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ error, ...props }, ref) => {
    return <MantineTextarea ref={ref} error={error} minRows={4} {...props} />;
  }
);

Textarea.displayName = "Textarea";

interface SelectProps extends Omit<MantineSelectProps, "data" | "error"> {
  error?: string;
  options: { value: string; label: string }[];
}

export const Select = forwardRef<HTMLInputElement, SelectProps>(
  ({ options, error, ...props }, ref) => {
    return <MantineSelect ref={ref} data={options} error={error} {...props} />;
  }
);

Select.displayName = "Select";

interface CheckboxProps extends Omit<MantineCheckboxProps, "label"> {
  label: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({ label, ...props }, ref) => {
  return <MantineCheckbox ref={ref} label={label} {...props} />;
});

Checkbox.displayName = "Checkbox";
